import { Control, Controller } from "react-hook-form";
import { LucideIconPicker } from "@/components/UI/LucideIconPicker";

interface IconPickerFieldProps {
  name: string;
  control?: Control<any>;
  label?: string;
  isDisabled?: boolean;
  isLarge?: boolean;
  side?: "right" | "left" | "bottom" | "top";
  align?: "start" | "end";
}

export const IconPickerField = ({
  name,
  control,
  label = "Icon",
  isDisabled,
  isLarge,
  side = "bottom",
  align = "start",
}: IconPickerFieldProps) => {
  return (
    <Controller
      control={control}
      name={name}
      render={({ field }) => (
        <div className={isDisabled ? "pointer-events-none opacity-50" : ""}>
          <LucideIconPicker
            value={field.value ?? ""}
            onChange={field.onChange}
            label={label}
            isLarge={isLarge}
            side={side}
            align={align}
          />
        </div>
      )}
    />
  );
};
